import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Grid } from '@material-ui/core'
import SelectCompanyContext from './selectCompanyContext'
import { CustomFullPageWrapper } from './styles'
import { useAuth } from '../../../auth/useAuth'
import mapDispatchToProps from './mapDispatchToProps'
import LoginDialog from '../loginDialog/index'

const SelectCompany = (props) => {
  const { user } = props
  const { getIdentity } = useAuth()
  const [companyList, setCompanies] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorText, setErrorText] = useState('')

  const onSelectCompany = (company) => {
    setSelectedCompany(company)
  }

  const onSuccessGetCompany = (response) => {
    props.cognitoLoginUser({ user, company: response.company })
  }

  const onFailGetCompany = (err) => {
    setError(true)
    setErrorText('Error while trying to retrieve the company, please try again.')
  }

  const getCompany = () => {
    setLoading(true)
    getIdentity({ user, selectedCompanyId: selectedCompany.value, success: onSuccessGetCompany, fail: onFailGetCompany })
  }

  const onCloseError = () => {
    setLoading(false)
    setError(false)
    setErrorText('')
  }

  useEffect(() => {
    let subscribed = true
    if (subscribed) {
      const mapCompanies = () => (user ? user.companies.map((company) => ({ value: company.id, label: company.name })) : [])
      setCompanies(mapCompanies)
    }
    // eslint-disable-next-line no-return-assign
    return () => (subscribed = false)
  }, [])

  return (
    <CustomFullPageWrapper>
      <LoginDialog {...{ errorText, error, onCloseError }} />
      <CustomFullPageWrapper>
        <Grid
          container
          justify="center"
        >
          <SelectCompanyContext {...{ companyList, selectedCompany, setSelectedCompany: onSelectCompany, getCompany, loading, user }} />
        </Grid>
      </CustomFullPageWrapper>
    </CustomFullPageWrapper>
  )
}

export default compose(connect(null, mapDispatchToProps))(SelectCompany)
